import React from 'react';
import styled from 'styled-components';

interface Props {
    text: string;
    closeFunc?: (flag?: boolean) => void;
}

const ModalRemark: React.FC<Props> = ({ text }) => (
    <Wrapper>
        <RemarkArea readOnly defaultValue={text} rows={6} />
    </Wrapper>
);

export default ModalRemark;

const Wrapper = styled.div`
    width: 100%;
    padding: 0.25rem 0.25rem 0.5rem;
`;

const RemarkArea = styled.textarea`
    width: 100%;
    min-height: 8rem;
    background: ${({ theme }) => theme.colors.surface};
    border: 1px solid ${({ theme }) => theme.colors.inputBorder};
    border-radius: 0.875rem;
    padding: 0.625rem 0.875rem;
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: ${({ theme }) => theme.text.lg};
    color: ${({ theme }) => theme.colors.ink};
    outline: none;
    resize: vertical;
    direction: rtl;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.lg};
    }
`;
